import { DAY_OF_WEEK } from "./day-of-week.interfaces";

/**
 * Useful for mapping javascript's getDay() method (American order)
 */
export const DAYS_OF_WEEK: DAY_OF_WEEK[] = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

/**
 * Useful for displaying all days of week (french order)
 */
 export const DAYS_OF_WEEK_FOR_DISPLAY: DAY_OF_WEEK[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

/**
 * Useful for getting a label for api DAY_OF_WEEK
 */
export const DAY_OF_WEEK_LABEL = {
    "SUNDAY": "dimanche",
    "MONDAY": "lundi",
    "TUESDAY": "mardi",
    "WEDNESDAY": "mercredi",
    "THURSDAY": "jeudi",
    "FRIDAY": "vendredi",
    "SATURDAY": "samedi",
}